import React from 'react';
import { useUnit } from 'effector-react';
import Fade from 'react-reveal/Fade';
import { $scrollY } from 'src/models/app';

const goToHeader = () => {
  const header = document.getElementsByClassName('header')[0];
  header.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

export const ToTopButton = () => {
  const scrollY = useUnit($scrollY);

  return (
    <div className="to-top-button-container">
      <Fade bottom when={scrollY > 20} duration={250}>
        <div
          className={`to-top-button ${scrollY > 20 ? '' : 'pointers-none'}`}
          onClick={goToHeader}
          onTouchStart={goToHeader}
        >
          <ArrowSVG />
        </div>
      </Fade>
    </div>
  );
};

const ArrowSVG = () => (
  <svg
    width="60"
    height="60"
    className="rotate-arrow"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M26 20L34.9704 30L26 40" stroke="white" strokeWidth="3" />
  </svg>
);
